import { render, staticRenderFns } from "./FacebookPageSelect.vue?vue&type=template&id=56cb6f7e"
import script from "./FacebookPageSelect.vue?vue&type=script&lang=js"
export * from "./FacebookPageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports